import React from 'react';
import { FaStethoscope } from 'react-icons/fa';
import './StethoscopeLoading.css';

const LOADING_TEXT = 'Loading...';

const StethoscopeLoading = ({
    overlay = false,
    className = '',
    style,
}) => (
    <div
        className={`stethoscope-loading d-flex flex-column align-items-center justify-content-center${overlay ? ' stethoscope-loading--overlay' : ''}${className ? ` ${className}` : ''}`}
        style={style}
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
        <FaStethoscope className="stethoscope-loading__icon mb-3" aria-hidden />
        <span className="stethoscope-loading__text fw-semibold">{LOADING_TEXT}</span>
    </div>
);

export default StethoscopeLoading;
